import React from 'react';
import { Field } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

export const Label = ({ labelText }) => (
    <label className="bg-orange-800 text-white w-5/12 lg:w-3/12 flex text-left items-center text-xs px-4 ">
        {labelText}
    </label>
);

export const StyledField = ({ name, labelText, className = '', ...rest }) => {
    return (
        <div className={`flex border border-orange-800 ${className}`}>
            <Label labelText={labelText} />
            <Field
                name={name}
                className="w-7/12 lg:w-full p-4 outline-none text-xs lg:text-base"
                {...rest}
            />
        </div>
    );
};

export const StyledFieldTextarea = ({ name, placeholder, className = '', rows = 9, ...rest }) => {
    return (
        <div className={`border border-orange-800 ${className}`}>
            <Field
                className={`w-full p-4 resize-none outline-none text-xs lg:text-base ${className}`}
                name={name}
                component="textarea"
                rows={rows}
                placeholder={placeholder}
                {...rest}
            />
        </div>
    );
};

export const StyledSelectField = ({ name, labelText, options, value, className = '' }) => {
    return (
        <div className={`flex border border-orange-800 relative ${className}`}>
            <Label labelText={labelText} />
            <Field
                as="select"
                name={name}
                className="block appearance-none w-7/12 lg:w-full p-4 outline-none bg-white text-xs lg:text-base"
                defaultValue={value}
            >
                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </Field>
            <FontAwesomeIcon
                icon={faCaretDown}
                size="2x"
                className="invisible md:visible lg:visible xl:visible text-orange inline-block absolute"
                style={{ pointerEvents: 'none', top: '12px', right: '16px' }}
            />
        </div>
    );
};

export const Textbox = ({ labelText, type = 'text', placeholder = '', className = '' }) => {
    const [value, setValue] = React.useState('');
    const onChangeHandler = e => {
        setValue(e.target.value);
    };
    return (
        <div className={`flex border border-orange-800 ${className}`}>
            <Label labelText={labelText} />
            <input
                type={type}
                className="w-7/12 lg:w-full p-4 outline-none text-xs lg:text-base"
                value={value}
                onChange={onChangeHandler}
                placeholder={placeholder}
            />
        </div>
    );
};

export const Textarea = ({ placeholder = '', className = '', rows = 9 }) => {
    const [value, setValue] = React.useState('');
    const onChangeHandler = e => {
        setValue(e.target.value);
    };
    return (
        <div className={`border border-orange-800 ${className}`}>
            <textarea
                className="w-full p-4 resize-none outline-none text-xs lg:text-base"
                placeholder={placeholder}
                rows={rows}
                value={value}
                onChange={onChangeHandler}
            />
        </div>
    );
};

export const Button = ({ onClick, className = '', children }) => {
    return (
        <button type="button" className={`rounded bg-orange py-4 px-8 text-white ${className}`}>
            {children}
        </button>
    );
};

export const Select = ({ labelText, options, value, onChangeHandler, className = '' }) => {
    return (
        <div className={`flex border border-orange-800 ${className}`}>
            <Label labelText={labelText} />
            <select
                className="block appearance-none w-7/12 lg:w-full p-4 outline-none bg-white text-xs lg:text-base"
                defaultValue={value}
                onChange={onChangeHandler}
            >
                {options.map(option => (
                    <option value={option}>{option}</option>
                ))}
            </select>
        </div>
    );
};
